import $ from 'jquery';

function setTemplateFileInput() {
  const templateFile = (window.dataLayer && window.dataLayer[0].WPtemplateFile) || '';
  const templateFileId = (window.dataLayer && window.dataLayer[0].WPtemplateFileId) || '';
  const templateFileName = (window.dataLayer && window.dataLayer[0].WPtemplateFileName) || '';

  $("input[name='template_file']").val(templateFile);
  $("input[name='template_file_id']").val(templateFileId);
  $("input[name='template_file_name']").val(templateFileName);
}

function fillTemplateFileInfoInput() {
  setTemplateFileInput();
  $(document).on('enquire-form:opened', setTemplateFileInput);
}

export default fillTemplateFileInfoInput;
